import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import LineaSVG from '../assets/images/LineaCurvaPoliticaPrivacidad.svg'
import LineaMobileSVG from '../assets/images/LineaCurvaMobilePoliticaPrivacidad.svg'
import { sizes } from '../utils/breakpoints'
import { useMediaQuery } from 'react-responsive'
import Seo from '../components/Seo'

const CanalResponsable = () => {
  const isMobile = useMediaQuery({ maxWidth: sizes.mobile })
  const linea = isMobile ? LineaMobileSVG : LineaSVG

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title="Canal Responsable"
        description="Canal responsable de TARTIS para la comunicación de irregularidades."
        path="/canal-responsable"
      />
      <Title>Canal Responsable</Title>
      <ImgLinea src={linea} alt="" />
      <SectionInfo>
        <InfoSection>
          Está a punto de acceder al Canal Responsable compartido por las empresas del Grupo Plexus Tech, del que TARTIS Technologies, S.L. forma parte.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <InfoSection>Este canal es gestionado de forma centralizada por el Comité de Cumplimiento Normativo (CCN) del Grupo, garantizando un tratamiento objetivo, seguro y confidencial de todas las comunicaciones. Las personas que actúen de buena fe están protegidas frente a cualquier represalia.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <InfoSection>
          Si desea conocer el procedimiento de tramitación, puede consultarlo directamente en el canal.
        </InfoSection>
      </SectionInfo>


      <SectionInfo>
        <InfoSection>
          <EnalceExterno as="a"
            href="https://cr.marcafranca.com/canal/5716646702350336"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}> Acceder al canal responsable
          </EnalceExterno>
        </InfoSection>
      </SectionInfo>
    </Container>
  )
}

export default CanalResponsable

const Container = styled.div`
  margin-bottom: 70px;
`

const Title = styled.h1`
  padding: 158px 0 0 230px;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 40px;
  line-height: 48px;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (max-width: ${sizes.mobile}px) {
    padding: 70px 0 0 30px;
    font-size: 15px;
    line-height: 18px;
  }
`

const ImgLinea = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
`

const SectionInfo = styled.div`
  padding: 25px 293px 0 230px;
  margin-bottom: 30px;
  @media (max-width: ${sizes.mobile}px) {
    padding: 20px 40px 0 30px;
  }
`

const InfoSection = styled.span`
  font-family: 'fuenteRegularMont';
  font-size: 20px;
  line-height: 24.38px;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
    line-height: 14.63px;
  }
`

const EnalceExterno = styled.a`
  font-family: 'fuenteSemi';
  color: inherit;
  text-decoration: none;
`
